export default __webpack_public_path__ + "static/media/rounded-bottom.da816b40.webp";